import styled, { css } from 'styled-components';
import { Typography } from '../../../../global/theme';
import { mobile_xl } from '../../../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter } from '../../../../global/commonStyle';

interface Props {
  isOverdue?: boolean;
  hasContent?: boolean;
  isShowCompletedTask?: boolean;
  isShowAllCompletedTask?: boolean;
  hasGap?: boolean;
  hasLeftBorder?: boolean;
  isEmptyState?: boolean;
  color?: string;
}

const MilestoneList = styled.div<Props>`
  padding: var(--space-24);
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
  ${({ isEmptyState }) =>
    isEmptyState &&
    css`
      height: calc(100% - 95px);
    `}
  ${mobile_xl(css<Props>`
    padding: var(--space-0) var(--space-0) var(--space-96);
    ${({ isEmptyState }) =>
      isEmptyState &&
      css`
        height: calc(100% - 220px);
      `}
  `)}
`;

const Group = styled.div<Props>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-10);
  ${({ isEmptyState }) =>
    isEmptyState &&
    css`
      position: relative;
      height: 100%;
    `}
  ${mobile_xl(css`
    gap: var(--space-0);
  `)}
`;

interface SortableWrapperProps {
  isDragging?: boolean;
  cssTransform?: string | undefined;
  cssTransition?: string | undefined;
}

export const SortableWrapper = styled.div<SortableWrapperProps>`
  width: 100%;
  opacity: ${(props) => (props.isDragging ? 0.5 : 1)};
  transform: ${(props) => props.cssTransform || 'none'};
  transition: ${(props) => props.cssTransition || 'none'};
`;
const MilestoneItemContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: var(--space-10) var(--space-14);
  gap: var(--space-10);
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  box-shadow: var(--shadow-card);
  border-radius: var(--border-radius-12);
  position: relative;
  &:hover .dotted-icon {
    opacity: 1;
  }
  ${mobile_xl(css`
    padding: var(--space-12) var(--space-20);
    border-radius: var(--border-radius-0);
    border-width: 1px;
    border-style: none none solid;
    background: none;
    box-shadow: none;
    gap: var(--space-8);
    :first-child {
      padding-top: var(--space-8);
    }
    :last-child {
      border-bottom: none;
    }
  `)}
`;

const Content = styled.div`
  width: 100%;
  ${AlignCenter}
  gap: var(--space-10);
  p {
    ${Typography.body_md_medium}
    color: var(--text-secondary);
    margin: var(--space-0);
  }
  ${mobile_xl(css`
    flex-direction: column;
    align-items: flex-start;
  `)}
`;

const AssignGroup1 = styled.div`
  ul {
    display: flex;
    flex-wrap: wrap;
    list-style-type: none;
    padding: var(--space-0);
    margin: var(--space-0);
    justify-content: flex-end;
    height: 24px;
    width: max-content;
  }
  li {
    margin-left: -9px;
  }
  ${mobile_xl(css`
    li {
      :first-child {
        margin-left: var(--space-0);
      }
    }
  `)}
  .plus-icon {
    ${mobile_xl(css`
      display: none;
      width: 20px;
      border-radius: var(--border-radius-full);
      ${FlexCenter}
      color: var(--text-white);
      background: var(--text-secondary);
      border: 1px solid var(--background-primary);
      position: relative;
      top: 0;
      z-index: var(--z-index-base);
    `)}
  }
`;

const AvatarImage = styled.div`
  ${AlignCenter}
  border-radius: var(--border-radius-full);

  > div > img {
    max-width: 100%;
  }
`;

const Data = styled.div<Props>`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-top: 0.5px solid var(--border-primary);
  padding-top: ${(props) => (props.isShowAllCompletedTask ? 'var(--space-0)' : 'var(--space-5)')};
  ${(props) =>
    props.isShowCompletedTask &&
    css`
      border-top: none;
      padding-top: var(--space-0);
    `}
  ${mobile_xl(css`
    border-top: none;
    padding-top: var(--space-0);
  `)}
`;

const Second = styled.div<Props>`
  ${AlignCenter}
  padding: var(--space-0);
  width: 100%;
  justify-content: ${(props) => (props.hasContent ? 'space-between' : 'flex-end')};
  gap: var(--space-10);
`;

const MilestoneEmpty = styled.div`
  border-top: 0.5px solid var(--border-primary);
  padding-block: var(--space-20);
  .milestone-empty {
    margin-inline: auto;
    ${mobile_xl(css`
      border-top: none;
    `)}
  }
  ${mobile_xl(css`
    border-top: none;
    padding-block: var(--space-12);
  `)}
`;

const ShowHide = styled.a`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  cursor: pointer;
  max-width: 146px;
  width: 100%;
  &:hover {
    color: var(--text-primary);
  }
  ${mobile_xl(css`
    max-width: max-content;
  `)}
`;
const ShowTask = styled.div`
  display: flex;
  gap: var(--space-6);
  flex-direction: column;
`;
const Buttons = styled.div`
  text-align: center;
`;

const SVGDiv = styled.div`
  ${FlexCenter}
  ${mobile_xl(css`
    display: none;
  `)}
`;
export {
  MilestoneList,
  Group,
  MilestoneItemContent,
  Content,
  AssignGroup1,
  AvatarImage,
  Data,
  Second,
  MilestoneEmpty,
  ShowHide,
  ShowTask,
  Buttons,
  SVGDiv
};
